import * as React from "react"
import { List } from "immutable"
import { Jumbo } from "../components/jumbo"
import { CollectionSearchBar } from "../components/collection_search_bar"
import { Block, BlockRenderer } from "../components/block_renderer"
import { SearchBarWrapper } from "../components/search_bar"

export interface CollectionPageProps {
  readonly kind: "collection"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly imageUrl: string
  readonly imageAlt: string
  readonly buttonUrl: string
  readonly buttonTitle: string
  readonly header_blocks: List<Block>
  readonly blocks: List<Block>
  readonly pageLanguage: string
}

interface CollectionPageState {}

const collectionPageStateZero = {}

export class CollectionPage extends React.Component<CollectionPageProps, CollectionPageState> {
  constructor(props: CollectionPageProps) {
    super(props)

    this.state = collectionPageStateZero

    this.updateInput = this.updateInput.bind(this)

    document.title = this.props.pageTitle
  }

  updateInput(i: string, c?: () => void) {
    this.setState((s, _) => ({ ...s, input: i }), c)
  }

  render() {
    const p = this.props
    const s = this.state

    return (
      <div className="wide collection-page">
        <Jumbo
          headerTitle={p.headerTitle}
          contents={p.description}
          headerImageUrl={p.imageUrl}
          headerImageAlt={p.imageAlt}
          buttonUrl={p.buttonUrl}
          buttonTitle={p.buttonTitle}
          size="large"
          kind="collection"
        />
        <SearchBarWrapper>
          <CollectionSearchBar />
        </SearchBarWrapper>
        
        <BlockRenderer blocks={p.blocks} />
      </div>
    )
  }
}
